import { SearchOpportunitiesQuery } from '../types';

const buildQueryKey = ({
    agentId,
    searchQuery,
    createdAt,
    owner,
    score,
    pipelineId,
    stageIds,
    amount,
    tags,
    sortBy,
    sortOrder,
    pageSize,
    page = 1,
}: Omit<SearchOpportunitiesQuery, 'queryOptions'>) => {
    const key: unknown[] = ['opportunities', 'search'];
    if (agentId) {
        key.push(agentId);
    }
    if (searchQuery) {
        key.push(searchQuery);
    }
    if (createdAt) {
        key.push(createdAt);
    }
    if (owner) {
        key.push(owner);
    }
    if (tags) {
        key.push(tags);
    }
    if (score) {
        key.push(score);
    }
    if (pipelineId) {
        key.push(pipelineId);
    }
    if (stageIds) {
        key.push(stageIds);
    }
    if (amount) {
        key.push(amount);
    }
    if (sortBy) {
        key.push(sortBy);
    }
    if (sortOrder) {
        key.push(sortOrder);
    }
    if (pageSize) {
        key.push(pageSize);
    }

    key.push(page);

    return key;
};

export default buildQueryKey;
